<template>
    <div class="product-metadata">
        <div class="product-cover">
            <img :src="product.product_thumbnail_url" />
        </div>
        <div class="product-title">{{product.product_title}}</div>
        <div class="product-attribute product-subtitle capitalize">{{product.license_type}} Edition</div>
        <div class="product-spacer"></div>
        <div class="product-metadata-subtitle">Product License</div>
        <div class="product-attribute small">You have access to the {{product.license_type}} edition.</div>
        <div class="product-attribute small">Your license expires on {{product.license_expiration_date | pretty('long')}}.</div>
        <div class="product-spacer"></div>
        <div class="product-metadata-subtitle">Publisher &amp; Authors</div>
        <div class="product-attribute small">{{product.product_publishers}}</div>
        <div class="product-attribute small">{{product.product_authors}}</div>
        <div class="product-spacer"></div>
        <div class="product-metadata-subtitle">Copyright &amp; License</div>
        <div class="product-attribute small">{{product.product_copyright}}</div>
        <div class="product-attribute small">{{product.product_disclaimer}}</div>
        <a class="block product-attribute small product-license" target="_blank" :href="product.product_license_url">License Details</a>
        <div class="product-spacer"></div>
        <img class="openstax-ally" src="@/assets/openstax.png" />
    </div>
</template>

<script>
    export default {
        name: 'ProductMetadata',
        props: {
            product: Object
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .product-metadata
    {
        width: 340px;
        margin-left: 40px;
    }

    .product-cover
    {
        width: 340px;
        height: 420px;
        background: var(--card-background-color);
        border-radius: 5px;
        overflow: hidden;
        box-shadow: 0 4px 30px -2px rgba(0, 0, 0, 0.5);

        img
        {
            width: 100%;
        }
    }

    .product-title
    {
        line-height: 26px;
        color: var(--primary-text-color);
        padding-top: 30px;
        font-size: 24px;
        font-weight: 600;
    }

    .product-subtitle
    {
        margin-top: 5px;
    }

    .product-attribute
    {
        font-size: 15px;
        color: #888;
        line-height: 18px;

        &.small
        {
            font-size: 12px;
        }
    }

    .product-spacer
    {
        height: 1px;
        width: 80px;
        background: #555;
        margin: 30px 0;
    }

    .product-metadata-subtitle
    {
        font-size: 12px;
        margin-bottom: 5px;
        font-weight: 500;
        line-height: 18px;
        color: var(--primary-text-color);
    }

    .product-license
    {
        margin-top: 6px;
        color: @base;
    }

    .openstax-ally
    {
        width: 160px;
    }

    @media only screen and (max-width: 1100px)
    {
        .product-metadata
        {
            width: 289px;
            margin-left: 30px;
        }

        .product-cover
        {
            width: 289px;
            height: 357px;
            border-radius: 3px;
        }
    }
</style>